import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SwitchDataSetFieldIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SwitchDataSetField",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.41 30c-2.24 0-3.47 0-4.43-.86-.8-.72-.97-1.63-1-2.99-2.18-.02-3.49-.15-4.49-1.05-1.22-1.1-1.22-2.66-1.22-5.25v-2.68H12.9v1.03c0 4.1-3.41 4.1-5.44 4.1s-5.44 0-5.44-4.1v-4.4c0-4.1 3.41-4.1 5.44-4.1s5.44 0 5.44 4.1v1.03h3.37v-2.68c0-2.59 0-4.15 1.22-5.25 1-.9 2.32-1.03 4.49-1.05.04-1.35.2-2.27 1-2.99C23.94 2 25.17 2 27.41 2c.56 0 1.04 0 1.46.01.64.02 1.15.55 1.13 1.2-.02.64-.59 1.11-1.2 1.13-.4-.01-.87-.02-1.39-.01-1.49 0-2.57 0-2.87.26-.24.22-.24 1.14-.24 2.42s0 2.2.24 2.42c.3.27 1.38.27 2.87.27.52 0 .99 0 1.39-.01.6 0 1.18.49 1.2 1.13s-.49 1.18-1.13 1.2c-.42.01-.9.01-1.46.01-2.24 0-3.47 0-4.43-.87-.8-.72-.97-1.63-1-2.98-1.55.01-2.52.08-2.93.45-.43.39-.45 1.36-.45 3.51v7.7c0 2.16.02 3.13.45 3.51.41.37 1.38.44 2.93.45.04-1.35.2-2.26 1-2.98.96-.86 2.19-.86 4.43-.86.56 0 1.04 0 1.46.01.64.02 1.15.55 1.13 1.2-.02.64-.59 1.13-1.2 1.13-.4-.01-.87-.02-1.39-.01-1.5 0-2.58 0-2.87.26-.24.22-.24 1.14-.24 2.42s0 2.2.24 2.42c.3.27 1.38.27 2.87.27.52-.01.99 0 1.39-.01h.03c.63 0 1.15.5 1.17 1.13.02.64-.49 1.18-1.13 1.2-.42.01-.9.01-1.46.01ZM7.44 12.03c-2.98 0-3.11.4-3.11 1.77v4.4c0 1.37.13 1.77 3.11 1.77s3.11-.4 3.11-1.77v-4.4c0-1.37-.13-1.77-3.11-1.77"
    })
  }));
};